// extracted by mini-css-extract-plugin
export default {"container":"PointsContainer_container__0KaIF","columns":"PointsContainer_columns__xn5Nq","infoValue":"PointsContainer_infoValue__O3-Z+"};